module.exports = __webpack_public_path__ + "media/images/official/special_migration_08-11ed822bcf098886fc5c7265a0236fca.jpg";